import { FC, memo, useMemo, useState, useEffect } from 'react'
import clsx from 'clsx'

import HtmlContainer from 'containers/html-container/html-container'
import AboutNMO from './about-nmo'
import TemplateItem from './tempate-item'
import LectorsBlock from '../webinar-future/webinar-lectors/lectors'
import Accordeon from 'components/parts/accordeon/accordeon'
import JoinArrangment from './join-arrangment'
import BannerCrowdfunding from './banner-crowdfunding/banner-crowdfunding'

import { TemplateVariant } from 'constants/webinar-data'
import { nestApiPath } from 'constants/url'
import { getAxiosSingle } from 'pages/api/axios'
import { generateDateTimeFromSec } from 'utils/formatDate'
import { ILectur, ISpeciality } from 'constants/types/common.types'

import styles from './webinar-template.module.scss'

interface IHtmlContainer {
  id?: number
  linkTranslation?: string
  points?: number | null
  NMOTimeLength?: number
  checkupCount?: any
  privateKey: string
  Specialities?: ISpeciality[]
  Lecturs?: ILectur[]
  lecturName?: string
  eventType: string
  isActiveNMOCodes?: boolean
  hasSponsor?: boolean
  expertCouncil?: boolean
  description: string
  isEnded?: boolean
  withAcordeons?: boolean
  withCrowdFunding?: boolean
  titleModificator?: string
  modificator?: string
  isWebinar?: boolean
  isHybrid?: boolean
  isWithTimecodes?: boolean
  ABVersion?: string
  materialType?: string
  handleTimeCode?: (time: number) => void
}

const WebinarTemplate: FC<IHtmlContainer> = ({
  id,
  linkTranslation,
  points,
  NMOTimeLength,
  checkupCount,
  privateKey,
  Specialities,
  Lecturs,
  lecturName,
  eventType,
  isActiveNMOCodes,
  hasSponsor,
  expertCouncil,
  description,
  isEnded,
  titleModificator,
  withAcordeons,
  withCrowdFunding,
  modificator,
  materialType,
  isWithTimecodes,
  handleTimeCode,
}) => {
  const [timecodes, setTimeCodes] = useState([])
  const linkMainPart = linkTranslation || id
  const formedLink = privateKey ? `${linkMainPart}?key=${privateKey}` : linkMainPart
  const specsForWebinar =
    Specialities && Specialities.length
      ? Specialities.map((speciality) => speciality.name.toLowerCase()).join(', ')
      : ''

  const templateItemTitle = useMemo(() => {
    if (isEnded) return 'Описание'
    if (expertCouncil) return 'Об экспертном совете'

    return `О ${TemplateVariant.title[eventType]}`
  }, [expertCouncil, isEnded, eventType])

  useEffect(() => {
    const getTimecode = async () => {
      if (isWithTimecodes) {
        const result = await getAxiosSingle(
          `${nestApiPath}/timecode?materialType=${materialType}&materialId=${id}`
        )
        setTimeCodes(result.timecodes)
      }
    }
    getTimecode()
  }, [])

  return (
    <div className={styles.webinarTemplate}>
      {Lecturs && (
        <div className={clsx({ [modificator as string]: modificator })}>
          <LectorsBlock Lecturs={Lecturs} lecturName={lecturName} />
        </div>
      )}
      {description && (
        <div
          className={clsx({
            [modificator as string]: modificator,
            [styles.accordeon]: withAcordeons,
          })}
        >
          <TemplateItem title={templateItemTitle} titleModificator={titleModificator}>
            <HtmlContainer htmlContent={description}>
              {Boolean(specsForWebinar && points) && !isEnded && (
                <>
                  <br />
                  <p>
                    <b className={styles.caption}>
                      Мероприятие подано на аккредитацию НМО по специальностям:{' '}
                    </b>
                    <br />
                    <br />
                    <span className={styles.specialties}>{specsForWebinar}.</span>
                  </p>
                </>
              )}
            </HtmlContainer>

            {timecodes &&
              timecodes.map(({ time, idx, description: descrTimecode }) => {
                return (
                  <div className={styles.timecodes} key={idx}>
                    <div className={styles.timecode} onClick={() => handleTimeCode?.(time)}>
                      <span> {generateDateTimeFromSec(time)}</span> - {descrTimecode}
                    </div>
                  </div>
                )
              })}
          </TemplateItem>
        </div>
      )}
      {isActiveNMOCodes && !isEnded && (
        <div
          className={clsx({
            [modificator as string]: modificator,
            [styles.accordeon]: withAcordeons,
          })}
        >
          {withAcordeons ? (
            <Accordeon
              title={'Условия соответствия требованиям НМО'}
              modificator="webinar"
              text={
                <AboutNMO
                  id={id}
                  points={points}
                  NMOTimeLength={NMOTimeLength}
                  checkupCount={checkupCount}
                  hasSponsor={hasSponsor}
                />
              }
            />
          ) : (
            <TemplateItem
              title="Условия соответствия требованиям НМО:"
              titleModificator={titleModificator}
            >
              <AboutNMO
                id={id}
                points={points}
                NMOTimeLength={NMOTimeLength}
                checkupCount={checkupCount}
                hasSponsor={hasSponsor}
              />
            </TemplateItem>
          )}
        </div>
      )}

      {!isEnded && (
        <div
          className={clsx({
            [modificator as string]: modificator,
            [styles.accordeon]: withAcordeons,
          })}
        >
          {withAcordeons ? (
            <Accordeon
              title={'Подключение к мероприятию'}
              modificator="webinar"
              text={
                <JoinArrangment
                  formedLink={formedLink}
                  eventType={TemplateVariant.eventName[eventType]}
                />
              }
            />
          ) : (
            <TemplateItem title="Подключение к мероприятию" titleModificator={titleModificator}>
              <JoinArrangment
                formedLink={formedLink}
                eventType={TemplateVariant.eventName[eventType]}
              />
            </TemplateItem>
          )}
        </div>
      )}
      {withCrowdFunding && <BannerCrowdfunding />}
    </div>
  )
}

export default memo(WebinarTemplate)
